export default __webpack_public_path__ + "static/media/print_option.99f24928.svg";